<template>
  <v-card :height="height" class="elevation-3 d-flex align-end justify-center pa-4">
    <!-- <v-card-title class="pb-0">
      <span class="font-weight-light">Lorem ipsum dolor</span>
    </v-card-title> -->
    <apexchart
      :width="chartWidth"
      type="pie"
      :options="chartOptions"
      :series="series"
    />
  </v-card>
</template>

<script>
const dayjs = require('dayjs')
require('dayjs/locale/es')
dayjs.locale('es')

export default {
  props: {
    isDark: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    },
    chartWidth: {
      type: Number,
      default: 300
    }
  },

  data () {
    return {
      series: []
    }
  },

  computed: {
    chartOptions () {
      return {
        chart: {
          fontFamily: 'Mirai, sans-serif',
          width: this.chartWidth,
          type: 'pie'
        },
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: false
        },
        labels: this.labels,
        colors: this.colors,
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      }
    },

    data () {
      return Array(7)
        .fill({})
        .map((_) => {
          return this.generateNumber()
        })
    },

    labels () {
      return Array(5)
        .fill({})
        .map((_, i) => {
          return `Lorem ipsum ${i + 1}`
        })
    },

    colors () {
      return ['#EF5350', '#5C6BC0', '#66BB6A', '#D4E157', '#9575CD', '#F06292', '#4DD0E1']
    }
  },

  mounted () {
    this.series = this.labels.map((_) => {
      return this.generateNumber()
    })
  },

  methods: {
    generateNumber (min = 0, max = 100) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>
